import { Validator } from './vee-validate';
import RegexStr from './common/RegexStr';
var letterNumCnRegex = new RegExp(RegexStr.letter_num_cn);
var configs = [
    {
        name: "letter_num_cn",
        getMessage: function (field) { return field + ' 格式无效'; },
        validate: function (value) { return letterNumCnRegex.test(value); }
    },
    {
        name: "array_not_empty",
        getMessage: function (field) { return field + ' 不能为空'; },
        validate: function (value) { return value && value.length; }
    },
    {
        name: "array_not_empty_rela",
        getMessage: function (field) { return field + ' 不能为空'; },
        validate: function (value, _a) {
            var prevValue = _a[0];
            if (!prevValue) {
                return true;
            }
            return value && value.length;
        },
        hasTarget: true
    },
    {
        name: "require50_rela",
        getMessage: function (field) { return field + ' 不能为空'; },
        validate: function (value, _a) {
            var prevValue = _a[0];
            if (!prevValue) {
                return true;
            }
            return value && value.length <= 50;
        },
        hasTarget: true
    }
];
Validator.skipRequireds = ['require50_rela'];
function extendValidator() {
    configs.forEach(function (config) {
        Validator.extend(config.name, {
            getMessage: config.getMessage,
            validate: config.validate
        }, {
            hasTarget: !!config.hasTarget,
            computesRequired: true
        });
        var container = Validator.dictionary.container;
        if (container) {
            for (var locale in container) {
                if (container.hasOwnProperty(locale)) {
                    var localeConfig = container[locale];
                    Object.defineProperty(localeConfig.messages || {}, config.name, {
                        configurable: false,
                        writable: false,
                        enumerable: true,
                        value: config.getMessage
                    });
                }
            }
        }
    });
}
export default extendValidator;
